module.exports = __webpack_public_path__ + "img/logoariablanco.f87ac744.svg";